import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "@/auth/useAuth";
import { MfaSetupRequired } from "@/components/account/MfaSetupRequired";
import { AppShell } from "./AppShell";
import { SplashScreen } from "./SplashScreen";

export function ProtectedLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <SplashScreen />;
  if (!user) return <Navigate to="/login" replace />;

  // Verification gate (mirrors the backend VERIFICATION_REQUIRED 403): a logged-in
  // user that hasn't confirmed e-mail (or phone, when they have one) may only see
  // the verification screen — never the app shell — until everything is verified.
  // Redirect to the declared /verificar route so the screen is served by the
  // router (the route renders VerifyAccountPage); avoid looping when already there.
  const pending = !user.emailVerified || (user.hasPhone && !user.phoneVerified);
  if (pending && location.pathname !== "/verificar") return <Navigate to="/verificar" replace />;
  if (!pending && location.pathname === "/verificar") return <Navigate to="/" replace />;

  // MFA gate (mirrors the backend MFA_SETUP_REQUIRED 403): a platform admin
  // without MFA must enroll before reaching the app shell. Runs after the
  // verification gate so verification always comes first.
  if (user.isPlatformAdmin && !user.mfaEnabled) return <MfaSetupRequired />;

  // The matched child route is served by the AppShell's <Outlet />. The /verificar
  // route renders VerifyAccountPage; when pending we are redirected to it above.
  return pending ? <Outlet /> : <AppShell />;
}
